module.exports = __webpack_public_path__ + "static/img/zptp2.071e19f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/zptp2.jpg
// module id = IU0z
// module chunks = 11